var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex text-center items-center justify-center relative mb-5"
    },
    [
      _c(
        "div",
        {
          staticClass:
            "button-select transition-colors text-velux-grey-900  inline-flex w-auto text-base md:text-lg text-center flex-auto items-center justify-center relative py-3.5 md:p-3 px-7 font-bold last:mb-0",
          class: _vm.isActive
            ? "border-2 border-velux-red"
            : "border border-velux-grey-800",
          attrs: { role: "button", tabindex: "0" }
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm._t("tooltip")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }